import jwtAuthAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain } from "./management";

// ---------------- Articles ----------------

export const getArticles = async () => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get("/kiosk/article");
  return data?.result;
};

export const addArticle = async (article) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/kiosk/article", article);
  return data?.result;
};

export const editArticle = async (article) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `/kiosk/article/${article.url}`,
    article
  );
  return data?.result;
};

export const deleteArticle = async (url) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(`/kiosk/article/${url}`);
  return data?.result;
};

// ---------------- Article Categories ----------------

export const getArticleCategories = async (customerId) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/kiosk/articleCategory?customerId=${customerId}`
  );
  return data?.result;
};

export const deleteArticleCategory = async (url) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(`/kiosk/articleCategory/${url}`);
  return data?.result;
};

export const addArticleCategory = async (category) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/kiosk/articleCategory", category);
  return data?.result;
};

export const editArticleCategory = async (category) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `/kiosk/articleCategory/${category.url}`,
    category
  );
  return data?.result;
};

// ---------------- Devices ----------------

export const getDevices = async () => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get("/kiosk/device");
  return data?.result;
};

export const getDevice = async (url) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(`/kiosk/device/${url}`);
  return data?.result;
};

export const deleteDevice = async (url) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(`/kiosk/device/${url}`);
  return data?.result;
};

export const addDevice = async (device) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/kiosk/device", device);
  return data?.result;
};

export const copyDevice = async (url) => {
  setBackendDomain(jwtAuthAxios);
  const {
    data: {
      result: { settings },
    },
  } = await jwtAuthAxios.get(`/kiosk/device/${url}`);
  settings.main.label += " copy";
  const {
    data: {
      result: { id },
    },
  } = await jwtAuthAxios.post("/kiosk/device", { settings });
  const { data } = await jwtAuthAxios.put(`/kiosk/device/${id}`, { settings });
  return id;
};

export const editDevice = async (device) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `/kiosk/device/${device.url}`,
    device
  );
  return data?.result;
};
